// Cart.js
// Bundle.js
export const buyXSaveY = (x, y, amountOfEligibleDiscountProducts) => {
  const discountAmount = y + (amountOfEligibleDiscountProducts - x) * y
  return discountAmount % 1 === 0 ? discountAmount : discountAmount.toFixed(2)
}

// ProductForm.js
export const buyXSaveYAddToCart = (x, y, quantityToAdd, checkouts) => {
  let discountAmount
  const amountOfProductsInCart = checkouts.lineItems.edges.reduce(
    (acc, { node: { quantity, title } }) => {
      // excludes Washing bag and gift wrapping
      return title === 'Washing Bag' || title === 'Gift wrapping'
        ? acc
        : acc + quantity
    },
    0,
  )

  if (amountOfProductsInCart > 0) {
    // show discount amount in product page separate from discount amount in cart
    discountAmount =
      (quantityToAdd + amountOfProductsInCart - (x - 1)) * y -
      ((amountOfProductsInCart - (x - 1)) * y > 0
        ? (amountOfProductsInCart - (x - 1)) * y
        : 0)
  } else {
    discountAmount =
      (quantityToAdd - (x - 1)) * y > 0 ? (quantityToAdd - (x - 1)) * y : 0
  }

  const showDiscount = discountAmount > 0

  return [showDiscount, discountAmount]
}
